import React, { useState } from 'react'
import parse from 'html-react-parser'

import { generateBodyPreview, regexList } from '../../../utils/helpers'

import { useInAppNotificationStyles } from '../../../hooks/styles/useInAppNotificationStyles'

const ReadMoreTypography = ({ renderBody }) => {
  const [expanded, setExpanded] = useState(false)

  const { ReadMoreTypography, StyledReadMoreButton } =
    useInAppNotificationStyles()

  const MAX_CHARS = 150
  const isLong = renderBody?.length > MAX_CHARS

  const displayText = expanded ? renderBody : renderBody?.slice(0, MAX_CHARS)
  const toggleExpanded = (e) => {
    e.stopPropagation()
    setExpanded(!expanded)
  }
  return (
    <div>
      <ReadMoreTypography>
        {parse(displayText)}
        {isLong && !expanded && '...'}
      </ReadMoreTypography>

      {isLong && (
        <StyledReadMoreButton onClick={toggleExpanded}>
          {expanded ? 'Show less' : 'Read more'}
        </StyledReadMoreButton>
      )}
    </div>
  )
}

export const NotificationContent = ({ body, title }) => {
  const { NotificationContentContainer, NotificationContentTypography } =
    useInAppNotificationStyles()

  const renderBody = generateBodyPreview(body, regexList)

  return (
    <NotificationContentContainer>
      <NotificationContentTypography>{title}</NotificationContentTypography>

      {body && <ReadMoreTypography renderBody={renderBody} />}
    </NotificationContentContainer>
  )
}
